<script lang="ts" setup>

import { useNuxtApp } from '#app';

const { '$wagmi': { account } } = useNuxtApp();

const { isConnected, address, chain } = account;

</script>

<template>
  <div :class="!isConnected || !chain && 'wallet-helper'"
       class="display-flex flex-column align-items-start align-self-stretch grow"
  >
    <Transition mode="out-in"
                name="fade"
    >
      <div v-if="isConnected && chain"
           key="account"
           class="align-self-stretch"
      >
        <Suspense>
          <template #fallback>
            <div class="suspense-helper">
              <LoaderDots />
            </div>
          </template>
          <LazyWeb3Account :address="address!"
                           :chain-name="chain!.name"
          />
        </Suspense>

      </div>
      <div v-else-if="!chain && !isConnected"
           key="connector-list"
           class="align-self-stretch"
      >
        <Suspense>
          <template #fallback>
            <div class="suspense-helper">
              <LoaderDots />
            </div>
          </template>
          <LazyWeb3ConnectorList />
        </Suspense>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>

.suspense-helper {
  padding-top: 24px;
  padding-bottom: 24px;
}

.wallet-helper {
  @include desktop-1920 {
    padding-top: 0;
  }

  @include tablet-768 {
    margin-top: 20px;
    padding-top: 20px;
    //border-top: 1px solid #505054;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
